import { useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "../utils/tailwind.css";
import { useStore } from "../utils/context";
import Modal from "../components/modal";
import Const from "../utils/constant";
import cx from "../utils/tailwind-merge";
import LogoImage from "../assets/images/logo.webp";
import Label from "../components/label";

const Sidebar = () => {
  const location = useLocation();

  const isActiveTab = (tab) => location.pathname.startsWith(tab);
  const { handleLogout } = useStore();
  const [isModalOpen, setIsOpenModal] = useState(false);

  const menu = Const.MENU_ITEMS.PAGES;
  const masterMenu = Const.MENU_ITEMS.MASTER_PAGES;

  const handleLogoutClick = () => {
    handleLogout();
  };

  return (
    <div className="w-[15rem] border z-[10] h-[100%] flex flex-col justify-between fixed pt-2 overflow-scroll pb-[2rem] bg-[white] custom-scrollbar">
      <Navbar variant="light" className="flex flex-col ">
        <img
          src={LogoImage}
          className="w-[100px] h-[55px] object-fill  "
          alt="Login"
        />
        <Modal
          title="Confirm"
          desc="Are you sure you want to logout ?"
          isModalOpen={isModalOpen}
          setIsOpen={setIsOpenModal}
          handleSubmit={handleLogoutClick}
          confirmButtonLabel="Logout"
        />
        <Label
          label="Screens"
          className="mt-[9px] mb-3 pt-2 border-t-[1px] text-[16px] pl-3 w-full"
        />
        {menu.map((item) => {
          const isActive = isActiveTab(item.link);
          return (
            <>
              <div
                key={item.id}
                className={cx(
                  "w-100 px-3 border-l-4 border-l-transparent",
                  isActive && "border-l-[black]"
                )}>
                <Nav
                  className={cx(
                    "flex-column w-100 py-1.5",
                    isActive && "!bg-primary text-white rounded-[10px]"
                  )}>
                  <Nav.Link
                    as={Link}
                    to={item.link}
                    className={cx(
                      "!flex items-center gap-4 px-3 py-2 text-[#2C2C2C]",
                      isActive && "text-white"
                    )}>
                    <span
                      className={cx(
                        "w-6 h-6 text-[#2C2C2C]",
                        isActive && "text-white"
                      )}>
                      <item.icon />
                    </span>
                    {item.label}
                  </Nav.Link>
                </Nav>
              </div>
            </>
          );
        })}
        <Label
          label="Masters"
          className="mt-[9px] mb-3 pt-2 border-t-[1px] text-[16px] pl-3 w-full"
        />
        {masterMenu.map((item) => {
          const isActive = isActiveTab(item.link);
          return (
            <>
              <div
                key={item.id}
                className={cx(
                  "w-100 px-3 border-l-4 border-l-transparent",
                  isActive && "border-l-[black]"
                )}>
                <Nav
                  className={cx(
                    "flex-column w-100 py-1.5",
                    isActive && "!bg-primary text-white rounded-[10px]"
                  )}>
                  <Nav.Link
                    as={Link}
                    to={item.link}
                    className={cx(
                      "!flex items-center gap-4 px-3 py-2 text-[#2C2C2C]",
                      isActive && "text-white"
                    )}>
                    <span
                      className={cx(
                        "w-6 h-6 text-[#2C2C2C]",
                        isActive && "text-white"
                      )}>
                      <item.icon />
                    </span>
                    {item.label}
                  </Nav.Link>
                </Nav>
              </div>
            </>
          );
        })}
      </Navbar>
    </div>
  );
};

export default Sidebar;
